import { FunctionComponent } from 'react';
import styles from './Transaction.module.css';
import PaymentMethod from './PaymentMethod';
import { Moment } from 'moment-timezone';
import { Option } from '@spike/model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

interface TransactionProps {
    paymentMethodId?: string;
    paymentMethodName?: string;
    cardDigits?: string;
    amount?: string;
    channel?: string;
    type: string;
    date?: Moment;
    status?: Option<string>;
    isRefund?: boolean;
    onViewPayment?: () => void;
}

const formatTransactionAmount = (amount?: string): string => Number(amount ?? 0).toFixed(2);

export const Transaction: FunctionComponent<TransactionProps> = props => (
    <div>
        <div
            className={styles.container}
            onClick={props.onViewPayment}
        >
            <div className={styles.transactionData}>
                <p className={styles.text}>{props.date?.format('MMM DD, YYYY · h:mma')}</p>
                <PaymentMethod
                    paymentMethodId={props.paymentMethodId || ''}
                    paymentMethodName={props.paymentMethodName || ''}
                    cardDigits={props.cardDigits || null}
                    isRefund={props.isRefund}
                />
                {props.channel ? (
                    <p className={styles.text}>
                        {props.channel} · {props.type}
                    </p>
                ) : (
                    <p className={styles.text}>{props.type}</p>
                )}
            </div>
            <div className={styles.transactionAmount}>
                <FontAwesomeIcon
                    icon={faCheckCircle}
                    className={styles.icon}
                />
                <p className={styles.amount}>${formatTransactionAmount(props.amount)}</p>
            </div>
        </div>
    </div>
);

export default Transaction;
